import { MissingDocsCard } from "../components/docs/MissingDocsCard";
import axios from "axios";
import { EmpExtraFilters, matchExtra } from "../components/EmpExtraFilters";
import { useState, useEffect, useCallback, useRef, lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../components/ui/sheet";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "../components/ui/dropdown-menu";
import {
  Avatar, AvatarFallback, AvatarImage,
} from "../components/ui/avatar";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../components/ui/alert-dialog";
import {
  Plus, Settings, RefreshCw, ShieldCheck, Shield, Search, BellRing, LogOut, ChevronDown, AlertTriangle, Upload, FileBarChart, UserCog, Eye, X, FileSpreadsheet, Building2, MessageCircle, Clock, Sparkles, LayoutGrid, Landmark, CreditCard, CarFront } from "lucide-react";
import { api, fullExportUrl, namesVehiclesExportUrl, fileUrl, PF_TOKEN_KEY } from "../lib/api";
import { triggerDownload } from "../lib/download";
import { useAuth } from "../context/AuthContext";
import { MeetingsPanel } from "../components/business/MeetingsPanel";
import { MapPinned as NavMapIcon, Radar as NavRadarIcon } from "lucide-react";
import { CalendarDays as NavCalIcon, MessagesSquare as NavMeetIcon, NotebookPen as NavWsIcon } from "lucide-react";
import { BusinessCalendar } from "../components/business/BusinessCalendar";
import { WorkspacePanel } from "../components/business/WorkspacePanel";
import { STATUS_LABELS, SUPPORT_WHATSAPP, setCustomStatuses, getCustomStatuses } from "../lib/constants";
import { InAppFilePreview } from "../components/InAppFilePreview";
import { StatsCards } from "../components/StatsCards";
import { UsageMeter } from "../components/UsageMeter";
import { EmployeeTable } from "../components/EmployeeTable";
import { EmployeeDialog } from "../components/EmployeeDialog";
import { EmployeeDetailDialog } from "../components/EmployeeDetailDialog";
import { ImportDialog } from "../components/ImportDialog";
import { MuqeemImportDialog } from "../components/MuqeemImportDialog";
import { RiderIdImportDialog } from "../components/RiderIdImportDialog";
import { PlanPickerDialog } from "../components/PlanPickerDialog";
import { MergedDocsExportDialog } from "../components/MergedDocsExportDialog";
import { ShareLinkDialog } from "../components/ShareLinkDialog";
import { ReportDialog } from "../components/ReportDialog";
import { OverviewPanel } from "../components/OverviewPanel";
import { EmpDocsStats } from "../components/EmpDocsStats";
import { BranchesPanel } from "../components/BranchesPanel";
import { FaqContactsPanel } from "../components/FaqContactsPanel";
import { AnalyticsPanel } from "../components/AnalyticsPanel";
import { CustodyPanel } from "../components/CustodyPanel";
import { VehiclesPanel } from "../components/VehiclesPanel";
import { ChangePasswordDialog } from "../components/ChangePasswordDialog";
import { ForcePinGate } from "../components/ForcePinGate";
import { IqamaRenewalsButton } from "../components/IqamaRenewalsButton";
import { normSearch, toDigits } from "../lib/searchText";
import { KeyRound, Bot, Briefcase, Gavel, Library, FolderOpen, Fingerprint, FileSignature } from "lucide-react";
import DecisionsPanel from "../components/DecisionsPanel";
import { LegalPanel } from "../components/legal/LegalPanel";
import ContractsPanel from "../components/contracts/ContractsPanel";
import LibraryPanel from "../components/LibraryPanel";
import SaudiFilesPanel from "../components/SaudiFilesPanel";
import RiderCardsPanel from "../components/RiderCardsPanel";
import OutlookPanel from "../components/OutlookPanel";
import WaMessagesPanel from "../components/WaMessagesPanel";
import { TranslationReview } from "../components/TranslationReview";
import { setAutoOrg } from "../lib/autoTranslate";
import PrivateDocsPanel from "../components/PrivateDocsPanel";
import { AnnouncementsBar } from "../components/AnnouncementsBar";
import VarExpensesPanel from "../components/VarExpensesPanel";
import { BulkContractType, BulkPlatform } from "../components/EmpPickers";
import { BulkVehicleType, useVehicleTypes } from "../components/VehicleTypeTools";
import { BulkFuelChargeMode } from "../components/FuelChargeMode";
import { UploadCompliance } from "../components/UploadTracker";
import PnlPanel from "../components/PnlPanel";
import RentalsPanel from "../components/rentals/RentalsPanel";
import { BulkBranchBar } from "../components/BulkBranchBar";
import { EmployeesTrashButton } from "../components/EmployeesTrashDialog";
import { EmployeesExport } from "../components/EmployeesExport";
import { ReportExport } from "../components/ReportExport";
import { IdCard, Mail, Globe2, Calculator, LineChart as LineChartIcon } from "lucide-react";
import { RidersPanel } from "../components/RidersPanel";
import { RidersDailyPanel } from "../components/RidersDailyPanel";
import { RidersComparePanel } from "../components/RidersComparePanel";
import { RidersTargetPanel } from "../components/RidersTargetPanel";
import { RidersDistancesPanel } from "../components/RidersDistancesPanel";
import { TasksPanel } from "../components/TasksPanel";
import { WalletsPanel } from "../components/WalletsPanel";
import RiderCashPanel from "../components/ridercash/RiderCashPanel";
import RevenueForecast from "../components/RevenueForecast";
import { DocFolderImport } from "../components/DocFolderImport";
import { AccidentsPanel } from "../components/AccidentsPanel";
import { KeetaLinkExcel } from "../components/KeetaLinkExcel";
import { ReferralDialog, useReferralAutoClaim } from "../components/ReferralDialog";
import { SalesPanel } from "../components/SalesPanel";
import { AttendancePanel } from "../components/AttendancePanel";
import { AdvancesPanel } from "../components/AdvancesPanel";
import { ViolationsPanel } from "../components/ViolationsPanel";
import { RevenuePanel } from "../components/RevenuePanel";
import { ReportsHubPanel } from "../components/ReportsHubPanel";
import { OperatingCardsDialog } from "../components/OperatingCardsDialog";
import { NationalityMergeDialog } from "../components/NationalityMergeDialog";
import { InsurancePanel } from "../components/InsurancePanel";
import { PortalUsagePanel } from "../components/PortalUsagePanel";
import { SparePartsPanel } from "../components/SparePartsPanel";
import { CarMaintenancePanel } from "../components/CarMaintenancePanel";
import { MotoMaintenancePanel } from "../components/MotoMaintenancePanel";
import { FuelPanel } from "../components/FuelPanel";
import { SalariesPanel } from "../components/SalariesPanel";
import { LeaveBoard } from "../components/LeaveBoard";
import { InjuriesPanel } from "../components/InjuriesPanel";
import { LoyaltyPanel } from "../components/LoyaltyPanel";
import { PurchasesPanel } from "../components/PurchasesPanel";
import { PerfAlertsPanel } from "../components/PerfAlertsPanel";
import { LockedFeature } from "../components/LockedFeature";
import { Lock } from "lucide-react";
import { LifeBuoy } from "lucide-react";
import { RotateCcw } from "lucide-react";
import { Logo } from "../components/Logo";
import { CompanyRecordsPanel, LockerSection } from "../components/CompanyRecordsPanel";
import { AlertsPanel } from "../components/AlertsPanel";
import { CorrespondencePanel } from "../components/CorrespondencePanel";
import { CorrespondenceHub } from "../components/reports/CorrespondenceHub";
import { ApprovalInbox } from "../components/approvals/ApprovalInbox";
import { AdminReportsDueCard } from "../components/reports/AdminReportsPanel";
import { NotificationBell } from "../components/NotificationBell";
import { PhotoRequestsButton } from "../components/PhotoRequestsButton";
import { OrgStructureDialog } from "../components/org/OrgStructureDialog";
import { PreviewBanner } from "../components/org/PreviewBanner";
import { MgrApprovalsButton } from "../components/org/MgrApprovalsButton";
import { moduleOf } from "../lib/permGroups";
import { InfoHub } from "../components/InfoHub";
import { PlatformBoxes } from "../components/PlatformBoxes";
import { RentedAccountsPanel } from "../components/RentedAccounts";
import { BulkTools } from "../components/BulkTools";
import { startTour, DEMO_TOUR, DEMO_TOUR_KEY } from "../lib/baraaTour";
import { PermissionsOverview } from "../components/PermissionsOverview";
import { AdminOrgsDialog } from "../components/AdminOrgsDialog";
import { AdsCarousel } from "../components/AdsCarousel";
import { FinLinkPanel } from "../components/FinLinkPanel";
import { MarketingAdminPanel } from "../components/MarketingAdminPanel";
import { CompanySettingsDialog } from "../components/CompanySettingsDialog";
import { StatementDialog } from "../components/StatementDialog";
import { SupportWidget } from "../components/SupportWidget";
import { mostUrgentDoc } from "../components/DocStatus";
import { useLang } from "../i18n/LanguageContext";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { PushToggle } from "../components/PushToggle";
import { buildNavModel } from "../lib/navLayout";
import { applyTheme, normalizeTheme } from "../lib/themes";
import { useBackNav } from "../hooks/use-back-nav";
import { BackBar } from "../components/BackBar";
import { UpcomingAlerts } from "../components/UpcomingAlerts";
import {
  Home, Users, LayoutDashboard, BarChart3, Bike, PackageCheck, Car, FileText, UserRoundCheck, Wallet,
  TrafficCone, ChartNoAxesCombined, Wrench, Fuel, Banknote, Gift, CalendarDays, Award, ShoppingCart,
  TrendingUp, Clock3, HandCoins, Megaphone, Menu, HelpCircle, Smartphone, Truck, Boxes, ExternalLink, LogIn, HeartPulse, Route, Target, MessagesSquare, ClipboardList,
} from "lucide-react";
const RiderMapPanel = lazy(() => import("../components/RiderMapPanel"));
const LiveRosterPanel = lazy(() => import("../components/live/LiveRosterPanel"));

const NAV_ICONS = {
  overview: Home,
  meetings: NavMeetIcon,
  workspace: NavWsIcon,
  "biz-calendar": NavCalIcon,
  employees: Users,
  hr: UserCog,
  branches: LayoutDashboard,
  analytics: BarChart3,
  custody: PackageCheck,
  assets: Boxes,
  vehicles: Car,
  fleet: Truck,
  company: FileText,
  correspondence: MessagesSquare,
  riders: UserRoundCheck,
  "riders-daily": BarChart3,
  "riders-compare": BarChart3,
  "riders-target": Target,
  "riders-distances": Route,
  "riders-rented": Bike,
  wallets: Wallet,
  "rider-cash": Banknote,
  "salary-sim": LineChartIcon,
  violations: TrafficCone,
  accidents: CarFront,
  "portal-usage": Smartphone,
  revenues: TrendingUp,
  reports: ChartNoAxesCombined,
  spareparts: Wrench,
  maintenance: Wrench,
  "car-maintenance": Wrench,
  "moto-maintenance": Wrench,
  insurance: Shield,
  "insurance-all": Shield,
  "insurance-individuals": Shield,
  "insurance-cars": Shield,
  "insurance-moto": Shield,
  fuel: Fuel,
  salaries: Banknote,
  leave: CalendarDays,
  injuries: HeartPulse,
  loyalty: Award,
  purchases: ShoppingCart,
  "perf-alerts": BellRing,
  sales: TrendingUp,
  attendance: Clock3,
  advances: HandCoins,
  tasks: ClipboardList,
  admin: Briefcase,
  decisions: Gavel,
  library: Library,
  outlook: Mail,
  "wa-messages": MessageCircle,
  "private-docs": Lock,
  contracts: FileSignature,
  rentals: KeyRound,
  "saudi-files": FolderOpen,
  "rider-cards": IdCard,
  "rider-map": NavMapIcon,
  "live-roster": NavRadarIcon,
  alerts: Megaphone,
  "faq-contacts": HelpCircle,
  lockers: Lock,
};
const NavIcon = ({ value, className = "" }) => {
  const Icon = NAV_ICONS[value] || Home;
  return <Icon className={`h-[18px] w-[18px] shrink-0 ${className}`} strokeWidth={1.75} />;
};
const NAV_TRIGGER_CLS = "relative shrink-0 gap-2 rounded-xl px-3 text-slate-600 transition-colors hover:bg-slate-100 hover:text-blue-700 data-[state=active]:bg-blue-50 data-[state=active]:text-blue-700 data-[state=active]:font-semibold data-[state=active]:shadow-none data-[state=active]:after:absolute data-[state=active]:after:bottom-1 data-[state=active]:after:inset-x-3 data-[state=active]:after:h-0.5 data-[state=active]:after:rounded-full data-[state=active]:after:bg-blue-600";


export default function Dashboard() {
  const { t, dir } = useLang();
  const { user: authUser, logout, subscription } = useAuth();
  const [previewAs, setPreviewAs] = useState(null);
  const [orgOpen, setOrgOpen] = useState(false);
  const user = previewAs ? { ...authUser, ...previewAs } : authUser;
  const isManager = user?.role === "manager";
  const isOrgWide = ["manager", "hr_manager", "operations_manager", "accountant"].includes(user?.role) || Boolean(user?.org_wide);
  const canEdit = isOrgWide || user?.role === "supervisor" || Boolean(user?.can_edit);
  const [refOpen, setRefOpen] = useState(false);
  const [trOpen, setTrOpen] = useState(false);
  useEffect(() => { setAutoOrg(user?.org_id); }, [user?.org_id]);
  const [, setStatusTick] = useState(0);
  useEffect(() => { if (user?.org_id) api.getEmpStatuses().then((s) => { setCustomStatuses(s); setStatusTick((n) => n + 1); }).catch(() => {}); }, [user?.org_id]);
  const [docPreview, setDocPreview] = useState(null);
  useReferralAutoClaim(isManager);
  const isDemo = user?.org_id === "demo_org";
  const mperms = user?.module_perms || {};
  const restricted = !isManager && Object.keys(mperms).length > 0;
  const hasMatrix = !isManager && Object.keys(user?.perm_matrix || {}).length > 0;
  const moduleAllowed = (v) => v === "legal-cases" || !restricted || Boolean(mperms[moduleOf(v)]);
  const VIEW_FOR = { maintenance: "car-maintenance", insurance: "insurance-individuals", riders: "riders" };
  const concreteView = (k) => VIEW_FOR[k] || k;
  const roleLabel = { manager: t("dash.roles.manager"), hr_manager: t("dash.roles.hr_manager"), operations_manager: t("dash.roles.operations_manager"), accountant: t("dash.roles.accountant"), supervisor: t("dash.roles.supervisor"), user: canEdit ? t("dash.roles.editor") : t("dash.roles.viewer") }[user?.role] || t("dash.roles.employee");
  const isPlatformOwner = Boolean(subscription?.is_platform_owner);
  const feat = subscription?.features || null;
  const FEATURE_PLAN_AR = { branches: "الأعمال", analytics: "الأعمال", alerts: "الأعمال", riders: "الأعمال", salaries: "الأعمال", leave: "الأعمال", perf_alerts: "الأعمال", loyalty: "الأعمال", sales: "الاحترافية", custom_reports: "الاحترافية", custody: "الاحترافية", vehicles: "الاحترافية", attendance: "الاحترافية", advances: "الاحترافية", violations: "الاحترافية", fuel: "الاحترافية", spareparts: "الاحترافية" };
  const isLocked = (k) => Boolean(feat) && feat[k] === false;
  const gate = (k, node) => (isLocked(k)
    ? <LockedFeature requiredPlan={FEATURE_PLAN_AR[k]} currentPlan={subscription?.plan_details?.name_ar} supportWhatsapp={subscription?.support_whatsapp} />
    : node);
  const [adminOpen, setAdminOpen] = useState(false);
  const [marketingOpen, setMarketingOpen] = useState(false);
  const [marketingTab, setMarketingTab] = useState("overview");
  const [adminTab, setAdminTab] = useState("companies");
  const [statementOpen, setStatementOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [navExpanded, setNavExpanded] = useState({});
  const [navSearch, setNavSearch] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);
  const [reportDate, setReportDate] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [stats, setStats] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checking, setChecking] = useState(false);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [branchFilter, setBranchFilter] = useState("all");
  const [view, setView] = useState(() => sessionStorage.getItem("wz_view") || "overview");
  useEffect(() => { sessionStorage.setItem("wz_view", view); }, [view]);
  useBackNav("dash_view", view, setView);
  const backStack = useRef([]);
  const prevView = useRef(view);
  const backing = useRef(false);
  useEffect(() => {
    if (prevView.current === view) return;
    if (!backing.current) backStack.current.push(prevView.current);
    backing.current = false;
    prevView.current = view;
  }, [view]);
  const goBack = () => { backing.current = true; setView(backStack.current.pop() || "overview"); };
  const [selEmp, setSelEmp] = useState(() => new Set());
  useVehicleTypes();
  const [privateAllowed, setPrivateAllowed] = useState(false);
  useEffect(() => {
    if (!user || user.role === "manager") return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/private-docs/status`).then(() => setPrivateAllowed(true)).catch(() => setPrivateAllowed(false));
  }, [user]);
  useEffect(() => { window.__wzView = view; window.dispatchEvent(new Event("wz-view")); }, [view]);
  useEffect(() => () => { window.__wzView = null; window.dispatchEvent(new Event("wz-view")); }, []);
  useEffect(() => { const go = (e) => setView(e.detail); window.addEventListener("wz-goto", go); return () => window.removeEventListener("wz-goto", go); }, []);
  const [opCardsOpen, setOpCardsOpen] = useState(false);
  const [natOpen, setNatOpen] = useState(false);
  const [branches, setBranches] = useState([]);
  const [registeredBranches, setRegisteredBranches] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [pwOpen, setPwOpen] = useState(false);
  const [pfAvail, setPfAvail] = useState(false);
  useEffect(() => { if (authUser?.role === "manager") api.pfSwitchStatus().then((r) => setPfAvail(r.available)).catch(() => {}); }, [authUser?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const toPlatform = async () => {
    try { const r = await api.pfSwitch(); localStorage.setItem(PF_TOKEN_KEY, r.token); window.location.href = "/platform"; }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر فتح لوحة المنصة"); }
  };

  const [empDialog, setEmpDialog] = useState(false);
  const [editing, setEditing] = useState(null);
  const [viewing, setViewing] = useState(null);
  const [importOpen, setImportOpen] = useState(false);
  const [muqeemOpen, setMuqeemOpen] = useState(false);
  const [riderImportOpen, setRiderImportOpen] = useState(false);
  const [planDlgOpen, setPlanDlgOpen] = useState(false);
  const viewRef = useRef(null);
  useEffect(() => { if (view === "rider-cards" && subscription?.status === "trial" && !isPlatformOwner) setPlanDlgOpen(true); }, [view, subscription, isPlatformOwner]);

  const [mergedDocsOpen, setMergedDocsOpen] = useState(false);
  const [shareLink, setShareLink] = useState(null);
  const [reportOpen, setReportOpen] = useState(false);
  const [unreadCorr, setUnreadCorr] = useState(0);
  const canCorr = isOrgWide || user?.role === "supervisor";
  const bumpCorrUnread = useCallback(() => {
    if (!canCorr) return;
    api.correspondenceUnread().then((r) => setUnreadCorr(r.count || 0)).catch(() => {});
  }, [canCorr]);
  useEffect(() => {
    bumpCorrUnread();
    const id = setInterval(bumpCorrUnread, 30000);
    return () => clearInterval(id);
  }, [bumpCorrUnread]);
  const [companyOpen, setCompanyOpen] = useState(false);
  const [companyTab, setCompanyTab] = useState("profile");
  const [permRefresh, setPermRefresh] = useState(0);
  const [missingDoc, setMissingDoc] = useState(null);
  const [attrFilter, setAttrFilter] = useState(null);
  const [xf, setXf] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [sector, setSector] = useState("delivery");
  const [company, setCompany] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [emps, st, se, br] = await Promise.all([api.listEmployees(), api.stats(), api.getSettings(), api.branches()]);
      setEmployees(emps);
      setStats(st);
      setSettings(se);
      try { applyTheme(normalizeTheme(se?.theme)); } catch { /* theme non-blocking */ }
      setBranches(br);
      try { const cb = await api.companyBranches(); setRegisteredBranches((cb || []).map((b) => b.name).filter(Boolean)); } catch { /* non-blocking */ }
      try { const c = await api.getCompany(); setSector(c.sector || "delivery"); setCompany(c); } catch { /* non-blocking */ }
      try { const ro = await api.ridersOverview(); const ad = ro?.available_dates || []; setReportDate(ro?.date_used || (ad.length ? [...ad].sort().slice(-1)[0] : null)); } catch { /* non-blocking */ }
      try { const n = await api.notifications(); setNotifications(n.items || []); } catch { /* non-blocking */ }
    } catch {
      toast.error(t("dash.toast.loadFail"));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => { refresh(); }, [refresh]);
  // Another account logged in from a different tab shares the cookie: reload so this tab never mixes two companies' data.
  useEffect(() => {
    const check = () => api.me().then((m) => { if (user && m && (m.user_id !== user.user_id || m.org_id !== user.org_id)) window.location.reload(); }).catch(() => {});
    window.addEventListener("focus", check);
    return () => window.removeEventListener("focus", check);
  }, [user]);

  const runDemoTour = useCallback(() => startTour({ steps: DEMO_TOUR, doneKey: DEMO_TOUR_KEY, voiceToggle: true }), []);
  useEffect(() => {
    if (!isDemo || localStorage.getItem(DEMO_TOUR_KEY)) return undefined;
    const t = setTimeout(runDemoTour, 2000);
    return () => clearTimeout(t);
  }, [isDemo, runDemoTour]);

  // Baraa voice/text commands: open a section or dialog.
  useEffect(() => {
    const handle = ({ view: v, dialog }) => {
      if (dialog === "opcards") setOpCardsOpen(true);
      else if (dialog === "add-employee") { setEditing(null); setEmpDialog(true); }
      else if (dialog === "report") setReportOpen(true);
      else if (dialog === "import") setImportOpen(true);
      else if (v) {
        if (!moduleAllowed(v)) { toast.error("ليست لديك صلاحية لفتح هذا القسم"); return; }
        setView(v);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };
    const onOpen = (e) => handle(e.detail || {});
    window.addEventListener("baraa:open", onOpen);
    window.__wzDashReady = true;
    if (window.__baraaPending) { const p = window.__baraaPending; window.__baraaPending = null; setTimeout(() => handle(p), 600); }
    return () => { window.removeEventListener("baraa:open", onOpen); window.__wzDashReady = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restricted]);

  // Reset to overview if the active tab isn't available for this sector.
  useEffect(() => {
    if (!company) return;
    if (view === "riders" && sector !== "delivery") setView("overview");
    if ((view === "violations" || view === "reports") && sector !== "delivery") setView("overview");
    if (view === "sales" && sector !== "retail") setView("overview");
  }, [sector, view, company]);

  // Restricted users: redirect away from sections they are not allowed to see.
  useEffect(() => {
    if (restricted && !moduleAllowed(view)) {
      const first = Object.keys(mperms)[0];
      setView(first ? concreteView(first) : "overview");
    }
  }, [restricted, view, mperms]);

  useEffect(() => {
    const poll = async () => {
      try { const n = await api.notifications(); setNotifications(n.items || []); } catch { /* ignore */ }
    };
    const id = setInterval(poll, 30000);
    const onFocus = () => poll();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, []);

  const handleDelete = async () => {
    try {
      await api.deleteEmployee(deleteTarget.id);
      toast.success(t("dash.toast.empDeleted"));
      setDeleteTarget(null);
      refresh();
    } catch { toast.error(t("dash.toast.deleteFail")); }
  };

  const handleSaveSettings = async (form) => {
    try {
      const updated = await api.updateSettings(form);
      setSettings(updated);
      toast.success(t("dash.toast.settingsSaved"));
      refresh();
    } catch { toast.error(t("dash.toast.settingsFail")); }
  };

  const handleTestWhatsapp = async () => {
    const res = await api.testWhatsapp();
    if (res.sent) toast.success(t("dash.toast.waSent"));
    else if (res.reason === "credentials_missing") toast.warning(t("dash.toast.waMissing"));
    else if (res.reason === "no_destination") toast.warning(t("dash.toast.waNoDest"));
    else toast.error(t("dash.toast.waFail") + (res.reason || t("dash.toast.err")));
  };

  const handleTestEmail = async () => {
    const res = await api.testEmail();
    if (res.sent) toast.success(t("dash.toast.emailSent"));
    else if (res.reason === "email_credentials_missing") toast.warning(t("dash.toast.emailMissing"));
    else if (res.reason === "no_destination") toast.warning(t("dash.toast.emailNoDest"));
    else toast.error(t("dash.toast.emailFail") + (res.reason || t("dash.toast.err")));
  };

  const handleCheckNow = async () => {
    setChecking(true);
    try {
      const res = await api.checkNow();
      const parts = [];
      if (res.sent > 0) parts.push(t("dash.toast.checkWa", { n: res.sent }));
      if (res.email_sent > 0) parts.push(t("dash.toast.checkEmail", { n: res.email_sent }));
      if (parts.length) toast.success(t("dash.toast.checkSent", { checked: res.checked, parts: parts.join(" + ") }));
      else if (res.results.some((r) => r.whatsapp?.reason === "credentials_missing")) toast.warning(t("dash.toast.checkNeed", { n: res.results.length }));
      else toast.info(t("dash.toast.checkNone", { checked: res.checked }));
      refresh();
    } catch { toast.error(t("dash.toast.checkFail")); }
    finally { setChecking(false); }
  };

  const branchLabel = (e) => e.branch || "غير محدد";
  const branchOptions = [...new Set([...employees.map(branchLabel), ...registeredBranches])].sort();

  const duplicateIqamas = (() => {
    const counts = {};
    employees.forEach((e) => {
      const q = (e.iqama_number || "").trim();
      if (q) counts[q] = (counts[q] || 0) + 1;
    });
    return new Set(Object.keys(counts).filter((q) => counts[q] > 1));
  })();

  const filtered = employees.filter((e) => {
    const matchFilter = filter === "all" || e.overall_status === filter;
    const matchBranch = branchFilter === "all" || branchLabel(e) === branchFilter;
    const s = search.toLowerCase().trim();
    const sd = toDigits(s);
    const matchSearch = !s || [e.name, e.branch, e.employee_number, e.iqama_number, e.rider_id, e.profession, e.nationality, e.phone]
      .some((v) => String(v || "").toLowerCase().includes(s))
      || (/^\d{3,}$/.test(sd) && sd.length === s.replace(/\s/g, "").length && [e.phone, e.iqama_number, e.employee_number, e.rider_id, e.vehicle_plate]
        .some((v) => toDigits(v).includes(sd)));
    const matchMissing = !missingDoc || !(e.documents?.[missingDoc.key]?.expiry_date);
    let matchAttr = true;
    if (attrFilter) {
      let v;
      if (attrFilter.field === "nationality") v = (e.nationality || "").trim() || "غير محدد";
      else if (attrFilter.field === "profession") v = (e.profession || "").trim() || "غير محدد";
      else if (attrFilter.field === "vehicle") v = (e.vehicle_type || "").trim() || "غير محدد";
      else if (attrFilter.field === "natgroup") {
        const n = (e.nationality || "").trim().toLowerCase(), id = String(e.iqama_number || "").replace(/\D/g, "");
        v = (n.includes("سعود") || n.includes("saudi") || (!n && id.length === 10 && id.startsWith("1"))) ? "سعودي" : "مقيم";
      }
      else if (attrFilter.field === "active") {
        const st = (e.employee_status || e.tashark_status || "").trim();
        const ck = getCustomStatuses().find((c) => c.name === st)?.kind;
        v = ck ? (ck === "active" ? "نشط" : "غير نشط") : (!st || st.toLowerCase() === "active" || (st.includes("نشط") && !st.includes("غير"))) ? "نشط" : "غير نشط";
      }
      else if (attrFilter.field === "ids") v = attrFilter.ids.includes(e.id) ? attrFilter.value : null;
      else v = (e.employee_status || e.tashark_status || "").trim() || "غير محدد";
      matchAttr = v === attrFilter.value;
    }
    return matchFilter && matchBranch && matchSearch && matchMissing && matchAttr && matchExtra(e, xf);
  }).sort((a, b) => {
    // auto-sort by nearest document expiry (most urgent/overdue first)
    const ua = mostUrgentDoc(a), ub = mostUrgentDoc(b);
    const da = ua ? ua.days_left : 1e9;
    const db = ub ? ub.days_left : 1e9;
    if (da !== db) return da - db;
    return (a.name || "").localeCompare(b.name || "", "ar");
  });

  useEffect(() => { setPage(1); }, [search, filter, branchFilter, missingDoc, attrFilter, pageSize, xf]);
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const paged = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const initials = (user?.name || "؟").trim().charAt(0);

  const navAvailableBase = (v) => {
    if ((hasMatrix || restricted) && v !== "perf-alerts" && v !== "sales" && !(v === "legal-cases" && !hasMatrix)) return Boolean(mperms[moduleOf(v)]);
    switch (v) {
      case "overview": case "employees": case "branches": case "analytics":
      case "custody": case "company": case "attendance": case "advances":
      case "vehicles":
        return true;
      case "rentals":
        return canEdit;
      case "correspondence":
        return isOrgWide || user?.role === "supervisor";
      case "rider-map":
      case "live-roster":
        return user?.role === "manager" || isOrgWide || user?.role === "supervisor";
      case "outlook":
        return canEdit;
      case "wa-messages":
        return user?.role === "manager" || user?.role === "hr_manager";
      case "private-docs":
        return user?.role === "manager" || privateAllowed;
      case "insurance": case "salaries": case "leave": case "loyalty":
      case "purchases": case "alerts": case "lockers": case "faq-contacts":
      case "tasks":
        return true;
      case "injuries": case "decisions": case "library": case "saudi-files": case "rider-cards": case "contracts":
        return canEdit;
      case "violations": case "accidents": case "fuel": case "riders": case "wallets": case "rider-cash": case "salary-sim":
      case "portal-usage": case "revenues": case "reports": case "maintenance":
      case "meetings":
      case "workspace":
      case "biz-calendar":
        return isManager || Boolean(mperms.business);
      case "perf-alerts":
        return sector === "delivery" && canEdit;
      case "sales":
        return sector === "retail";
      case "reports-hub":
        return isOrgWide || canEdit;
      case "pnl":
        return isManager || user?.role === "accountant";
      case "var-expenses":
        return canEdit || Boolean(mperms["var-expenses"]);
      case "legal-cases":
        return true;
      case "legal-new": case "legal-archive":
        return user?.role === "manager" || ["legal-cases", "legal-new", "legal-archive"].some((k) => mperms[k]);
      default:
        return false;
    }
  };
  const navAvailable = (v) => navAvailableBase(v) && moduleAllowed(v);
  const trialLocked = subscription?.status === "trial" && !isPlatformOwner;
  const navLocks = {
    vehicles: isLocked("vehicles"), violations: isLocked("violations"), fuel: isLocked("fuel"),
    riders: isLocked("riders"), reports: isLocked("custom_reports"), loyalty: isLocked("loyalty"),
    sales: isLocked("sales"), branches: isLocked("branches"), analytics: isLocked("analytics"),
    custody: isLocked("custody"), "rider-cards": trialLocked,
  };
  const navModel = buildNavModel({
    layout: settings?.nav_config?.layout,
    labels: settings?.nav_config?.labels,
    available: navAvailable,
    locks: navLocks,
    t,
  });
  const secPerm = mperms[moduleOf(view)];
  // Edit is allowed when the user has the global edit grant (can_edit / editor role) OR the
  // section is explicitly granted "edit". Mirrors backend require_editor(user, module) exactly.
  const sectionCanEdit = canEdit || secPerm === "edit";

  return (
    <div className="min-h-screen" dir={dir}>
      {isDemo && (
        <div data-testid="demo-banner" className="sticky top-0 z-40 bg-gradient-to-l from-blue-600 to-indigo-600 text-white text-center text-sm py-2 pl-4 pr-16 sm:px-4 font-body flex items-center justify-center gap-3 flex-wrap">
          <span>🎬 نسخة تجريبية للعرض — جميع البيانات وهمية، جرّب الإضافة والتعديل والحذف بحرية</span>
          <Button size="sm" data-testid="demo-reset-button"
            className="h-7 gap-1.5 bg-white/20 hover:bg-white/30 text-white border border-white/40 rounded-full px-3"
            onClick={async () => {
              try {
                await api.demoReset();
                toast.success("تم تصفير النسخة التجريبية وإرجاع البيانات الأصلية");
                setTimeout(() => window.location.reload(), 600);
              } catch { toast.error("تعذّر التصفير"); }
            }}>
            <RotateCcw className="h-3.5 w-3.5" /> تصفير النسخة التجريبية
          </Button>
          <Button size="sm" data-testid="demo-tour-button" onClick={runDemoTour}
            className="h-7 gap-1.5 bg-white text-indigo-700 hover:bg-white/90 rounded-full px-3">
            <Sparkles className="h-3.5 w-3.5" /> إعادة الجولة
          </Button>
        </div>
      )}
      <button data-testid="view-select-mobile" onClick={() => setNavOpen(true)} aria-label="الأقسام"
            className="fixed top-3 right-3 sm:right-5 z-40 inline-flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white shadow-sm text-slate-700 transition hover:border-blue-300 hover:text-blue-600 active:scale-95">
            <Menu className="h-6 w-6" />
            {unreadCorr > 0 && <span data-testid="corr-hamburger-dot" className="absolute -top-1 -left-1 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white" />}
          </button>
      <header className="sticky top-0 z-30 backdrop-blur-md bg-white/80 border-b border-slate-200/60">
        <div className="mx-auto max-w-6xl pr-16 pl-3 sm:px-20 xl:px-8 py-3 flex items-center gap-3">
        <div className="flex-1 min-w-0 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2.5">
            {company?.logo_id ? (
              <div className="flex items-center gap-2.5" data-testid="company-header-logo" dir="ltr">
                <img src={fileUrl(company.logo_id)} alt={company.name || "logo"} className="h-9 w-9 object-contain rounded-lg" />
                <span className="font-heading font-extrabold tracking-tight text-xl text-slate-900">{company.name || "WorkZone"}</span>
              </div>
            ) : (
              <Logo size="md" />
            )}
            <Badge data-testid="role-badge" variant="outline"
              className={`inline-flex gap-1 rounded-full text-xs ${isManager ? "border-blue-200 bg-blue-50 text-blue-700" : canEdit ? "border-sky-200 bg-sky-50 text-sky-700" : "border-slate-200 bg-slate-50 text-slate-600"}`}>
              {isManager ? <ShieldCheck className="h-3 w-3" /> : canEdit ? <UserCog className="h-3 w-3" /> : <Eye className="h-3 w-3" />}
              {roleLabel}
            </Badge>
            {!isPlatformOwner && subscription && (
              <Badge data-testid="plan-badge" variant="outline"
                className={`inline-flex gap-1 rounded-full text-xs ${subscription.status === "trial" ? "border-amber-200 bg-amber-50 text-amber-700" : "border-emerald-200 bg-emerald-50 text-emerald-700"}`}>
                <Sparkles className="h-3 w-3" />
                {subscription.status === "trial"
                  ? `تجريبي · ${subscription.days_left ?? 0} يوم`
                  : `باقة ${subscription.plan_details?.name_ar || "الأعمال"}`}
              </Badge>
            )}
            {!isPlatformOwner && subscription && !subscription.complimentary && (
              <button data-testid="upgrade-plan-button" onClick={() => setPlanDlgOpen(true)}
                className="inline-flex items-center gap-1 rounded-full h-7 px-3 text-xs font-bold bg-gradient-to-l from-blue-600 to-indigo-600 text-white hover:opacity-90 active:scale-95 transition">
                <Sparkles className="h-3 w-3" /> {["professional", "enterprise"].includes(subscription.plan) ? "الاشتراك" : "ترقية"}
              </button>
            )}
            {!isPlatformOwner && isManager && !subscription?.complimentary && (
              <button data-testid="referral-open-button" onClick={() => setRefOpen(true)}
                className="inline-flex items-center gap-1 rounded-full h-7 px-3 text-xs font-bold bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-100 active:scale-95 transition">
                <Gift className="h-3 w-3" /> ادعُ شركة واربح شهراً
              </button>
            )}
            <ReferralDialog open={refOpen} onClose={() => setRefOpen(false)} />
          </div>
          <div className="flex items-center gap-2 flex-wrap justify-end">
            <a href="/finance" data-testid="open-finance-button"
              className="inline-flex items-center gap-1.5 h-9 rounded-md border border-teal-200 bg-white px-3 text-sm font-medium text-teal-700 hover:bg-teal-50 transition">
              <Landmark className="h-4 w-4" /> <span className="hidden sm:inline">WorkZone المحاسبي</span>
            </a>
            {canEdit && <FinLinkPanel />}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" data-testid="tools-menu-trigger" className="gap-1.5">
                  <LayoutGrid className="h-4 w-4" /> <span className="hidden sm:inline">{t("dash.header.tools") || "الأدوات"}</span>
                  <ChevronDown className="h-3.5 w-3.5 text-slate-400" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="font-body w-56">
                <DropdownMenuItem data-testid="open-report-button" onClick={() => setReportOpen(true)} className="gap-2">
                  <FileBarChart className="h-4 w-4 text-slate-500" /> {t("dash.header.report")}
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-my-telegram" className="gap-2 cursor-pointer"
                  onClick={async () => {
                    const w = window.open("", "_blank");
                    try { const r = await api.telegramMyLink(); if (w) w.location.href = r.url; else window.location.href = r.url; toast.success("اضغط «Start» في تلقرام لإكمال الربط"); }
                    catch (e) { w?.close(); toast.error(e?.response?.data?.detail || "تعذّر إنشاء رابط الربط"); }
                  }}>
                  <Bot className="h-4 w-4 text-sky-500" /> ربط حسابي بتلقرام
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuLabel className="text-xs text-slate-400 font-normal">روابط سريعة</DropdownMenuLabel>
                <DropdownMenuItem data-testid="link-employee-portal" className="gap-2 cursor-pointer"
                  onClick={() => setShareLink({ title: "رابط دخول الموظفين", url: `${window.location.origin}/employee?org=${user?.org_id || ""}` })}>
                  <LogIn className="h-4 w-4 text-blue-600" /> رابط دخول الموظفين
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-attendance" className="gap-2 cursor-pointer"
                  onClick={() => setShareLink({ title: "رابط تسجيل الحضور", url: `${window.location.origin}/employee?org=${user?.org_id || ""}&tab=attendance` })}>
                  <Clock3 className="h-4 w-4 text-emerald-600" /> رابط تسجيل الحضور
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-moto-maintenance" className="gap-2 cursor-pointer"
                  onClick={() => setShareLink({ title: "رابط صيانة الدراجات", url: `${window.location.origin}/m/moto-maintenance` })}>
                  <Wrench className="h-4 w-4 text-orange-600" /> رابط صيانة الدراجات
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-car-workshop" className="gap-2 cursor-pointer"
                  onClick={async () => { try { const r = await api.workshopLink(); setShareLink({ title: "رابط ورشة صيانة السيارات", url: `${window.location.origin}/workshop/${r.token}`, onRotate: async () => `${window.location.origin}/workshop/${(await api.workshopRotate()).token}` }); } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر إنشاء الرابط"); } }}>
                  <Wrench className="h-4 w-4 text-blue-600" /> رابط ورشة صيانة السيارات
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-demo" className="gap-2 cursor-pointer"
                  onClick={() => setShareLink({ title: "رابط العرض التجريبي (للتسويق)", url: `${window.location.origin}/demo` })}>
                  <Megaphone className="h-4 w-4 text-indigo-600" /> رابط العرض التجريبي
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-finance" className="gap-2 cursor-pointer"
                  onClick={() => setShareLink({ title: "رابط البرنامج المحاسبي", url: `${window.location.origin}/finance` })}>
                  <Landmark className="h-4 w-4 text-teal-600" /> رابط البرنامج المحاسبي
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="open-nat-merge" className="gap-2 cursor-pointer" onClick={() => setNatOpen(true)}>
                  <Globe2 className="h-4 w-4 text-sky-600" /> توحيد الجنسيات
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="link-bio-device" className="gap-2 cursor-pointer"
                  onClick={() => { setCompanyTab("biodevice"); setCompanyOpen(true); }}>
                  <Fingerprint className="h-4 w-4 text-emerald-600" /> رابط جهاز البصمة
                  <ExternalLink className="h-3 w-3 text-slate-300 ms-auto" />
                </DropdownMenuItem>
                {(
                  <>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem data-testid="open-import-button" onClick={() => setImportOpen(true)} className="gap-2">
                      <Upload className="h-4 w-4 text-slate-500" /> {t("dash.header.import")}
                    </DropdownMenuItem>
                    <DropdownMenuItem data-testid="open-rider-import-button" onClick={() => setRiderImportOpen(true)} className="gap-2">
                      <Upload className="h-4 w-4 text-indigo-600" /> استيراد معرفات المندوبين
                    </DropdownMenuItem>
                    {isManager && <DropdownMenuItem data-testid="open-users-button" onClick={() => setOrgOpen(true)} className="gap-2">
                      <UserCog className="h-4 w-4 text-slate-500" /> {t("dash.header.users")}
                    </DropdownMenuItem>}
                    <DropdownMenuItem data-testid="open-statement-button" onClick={() => setStatementOpen(true)} className="gap-2">
                      <FileText className="h-4 w-4 text-slate-500" /> كشف حساب المندوب
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuLabel className="text-xs text-slate-400 font-normal">{t("dash.header.exportsGroup") || "تصدير"}</DropdownMenuLabel>
                    <DropdownMenuItem asChild data-testid="full-export-button">
                      <a href={fullExportUrl} className="gap-2 cursor-pointer">
                        <FileSpreadsheet className="h-4 w-4 text-emerald-600" /> {t("dash.header.exportExcel")}
                      </a>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild data-testid="names-vehicles-export-button">
                      <a href={namesVehiclesExportUrl} className="gap-2 cursor-pointer">
                        <FileSpreadsheet className="h-4 w-4 text-emerald-600" /> {t("dash.header.ridersVehicles")}
                      </a>
                    </DropdownMenuItem>
                    <DropdownMenuItem data-testid="export-portal-passwords-button" className="gap-2 cursor-pointer"
                      onClick={async () => {
                        if (!window.confirm("سيتم توليد كلمات مرور مؤقتة جديدة لكل الموظفين (وتُبطل كلماتهم الحالية) لتوزيعها. هل تريد المتابعة؟")) return;
                        try {
                          const { file_id } = await api.exportPortalPasswords();
                          triggerDownload(api.filesDownloadUrl(file_id), "portal_passwords.xlsx");
                          toast.success("تم توليد كلمات المرور المؤقتة وتصديرها — وزّعها على الموظفين");
                        } catch (e) { toast.error("تعذّر التصدير"); }
                      }}>
                      <KeyRound className="h-4 w-4 text-amber-600" /> تصدير كلمات مرور البوابة
                    </DropdownMenuItem>
                    <DropdownMenuItem data-testid="export-password-cards-button" className="gap-2 cursor-pointer"
                      onClick={async () => {
                        if (!window.confirm("سيتم توليد كلمات مرور مؤقتة جديدة لكل الموظفين وإنشاء بطاقات PDF للطباعة. متابعة؟")) return;
                        try {
                          const { file_id } = await api.exportPortalPasswordCards();
                          triggerDownload(api.filesDownloadUrl(file_id), "portal_password_cards.pdf");
                          toast.success("تم إنشاء بطاقات الدخول PDF — جاهزة للطباعة والقص");
                        } catch (e) { toast.error("تعذّر إنشاء البطاقات"); }
                      }}>
                      <FileText className="h-4 w-4 text-rose-600" /> بطاقات دخول PDF
                    </DropdownMenuItem>
                    <DropdownMenuItem data-testid="merged-docs-export-trigger" className="gap-2 cursor-pointer"
                      onClick={() => setMergedDocsOpen(true)}>
                      <FileText className="h-4 w-4 text-indigo-600" /> تصدير وثيقة مجمّعة (PDF)
                    </DropdownMenuItem>
                  </>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
            {canEdit && !isDemo && (
              <Button size="sm" variant="outline" data-testid="backfill-birthdates-button"
                className="gap-1.5"
                onClick={async () => {
                  try {
                    const r = await api.backfillBirthdates();
                    toast.success(`جارٍ قراءة الهويات وتعبئة تاريخ الميلاد لـ ${r.queued} موظف (من ${r.total}). قد يستغرق دقائق.`);
                  } catch { toast.error("تعذّر بدء التعبئة"); }
                }}>
                <Sparkles className="h-4 w-4" /> تعبئة تواريخ الميلاد
              </Button>
            )}
            {canEdit && !isDemo && (
              <Button size="sm" variant="outline" data-testid="operating-cards-button"
                className="gap-1.5 border-amber-300 text-amber-700 hover:bg-amber-50"
                onClick={() => setOpCardsOpen(true)}>
                <CreditCard className="h-4 w-4" /> ضبط كروت التشغيل
              </Button>
            )}
            {canEdit && (!hasMatrix || user?.perm_matrix?.employees?.add) && (
              <Button size="sm" data-testid="add-employee-button"
                className="gap-1.5 bg-blue-600 hover:bg-blue-700 active:scale-95 transition"
                onClick={() => { setEditing(null); setEmpDialog(true); }}>
                <Plus className="h-4 w-4" /> {t("dash.header.addEmployee")}
              </Button>
            )}
            <LanguageSwitcher onReview={isManager ? () => setTrOpen(true) : undefined} />
            {isManager && <TranslationReview open={trOpen} onOpenChange={setTrOpen} orgId={user?.org_id} />}
            <PushToggle audience="user" compact />
            {canEdit && <PhotoRequestsButton onChanged={refresh} />}
            {!previewAs && <MgrApprovalsButton />}
            {view === "overview" && <NotificationBell
              items={stats?.upcoming || []}
              storageKey={`notif_seen_${user?.email || "anon"}`}
              alerts={notifications}
              onAlertsOpen={async () => {
                try { await api.readAllNotifications(); setNotifications((prev) => prev.map((n) => ({ ...n, read: true }))); } catch {}
              }}
              onAlertClick={(a) => { if (a?.type === "password_reset") setOrgOpen(true); else if (a?.type === "fuel_suspicious") setView("fuel"); else if (a?.type === "opcard_expiry") setOpCardsOpen(true); else if (a?.type === "card_received") setView("rider-cards"); else if (a?.type === "private_doc_expiry") setView("private-docs"); else if (a?.type === "rental_overdue") setView("rentals"); else if (a?.type === "ineligible_riders") setView("revenues"); else if (a?.type === "corr_read" || a?.type === "corr_message") { if (a.ref_id) sessionStorage.setItem("corr_open_once", a.ref_id); setView("correspondence"); } else if (a?.type === "admin_report_due") { sessionStorage.setItem("corr_tab_once", "reports"); setView("correspondence"); } else if (a?.type === "task_seen") setView("tasks"); else if (a?.type === "resignation_request") setView("decisions"); else if (a?.type === "keeta_face_fail") setView("riders"); else if (a?.type === "legal_case" || a?.type === "legal_overdue" || a?.type === "legal_timer") { if (a.ref_id) sessionStorage.setItem("legal_open_once", a.ref_id); setView("legal-cases"); } else if (a?.type === "doc_request") { sessionStorage.setItem("tasks_filter_once", "docs"); setView("tasks"); } else setView("custody"); }}
              onAlertDismiss={async (a) => {
                try { await api.deleteNotification(a.id); setNotifications((prev) => prev.filter((n) => n.id !== a.id)); } catch {}
              }}
              onSelect={(name) => { setView("employees"); setFilter("all"); setBranchFilter("all"); setSearch(name); }}
            />}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="user-menu-trigger" className="flex items-center gap-1.5 rounded-full hover:bg-slate-100 p-1 transition">
                  <Avatar className="h-8 w-8">
                    <AvatarImage src={user?.picture} />
                    <AvatarFallback className="bg-blue-100 text-blue-700 text-sm">{initials}</AvatarFallback>
                  </Avatar>
                  <ChevronDown className="h-4 w-4 text-slate-400" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="font-body">
                <div className="px-2 py-1.5 text-sm">
                  <p className="font-semibold text-slate-800">{user?.name}</p>
                  <p className="text-xs text-slate-400">{user?.phone ? `📱 ${user.phone}` : user?.email}</p>
                </div>
                {(user?.phone || isManager) && (
                  <DropdownMenuItem data-testid="change-password-menu" onClick={() => setPwOpen(true)} className="gap-2">
                    <KeyRound className="h-4 w-4" /> {t("dash.header.changePassword")}
                  </DropdownMenuItem>
                )}
                {isManager && (
                  <DropdownMenuItem data-testid="company-settings-menu" onClick={() => setCompanyOpen(true)} className="gap-2">
                    <Building2 className="h-4 w-4" /> {t("dash.header.companySettings")}
                  </DropdownMenuItem>
                )}
                {isPlatformOwner && (
                  <DropdownMenuItem data-testid="owner-support-menu" onClick={() => { setMarketingTab("support"); setMarketingOpen(true); }} className="gap-2 text-blue-700">
                    <LifeBuoy className="h-4 w-4" /> تذاكر الدعم الفني
                  </DropdownMenuItem>
                )}
                {pfAvail && (
                  <DropdownMenuItem data-testid="switch-to-platform-menu" onClick={toPlatform} className="gap-2 text-emerald-700">
                    <LayoutDashboard className="h-4 w-4" /> لوحة المنصة
                  </DropdownMenuItem>
                )}
                <DropdownMenuItem data-testid="logout-button" onClick={logout} className="text-red-600 gap-2">
                  <LogOut className="h-4 w-4" /> {t("dash.header.logout")}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 sm:px-8 py-8 space-y-8">
        {subscription?.status === "trial" && !isPlatformOwner && (
          <div data-testid="trial-banner" className="rounded-2xl border border-amber-200 bg-amber-50 p-4 flex items-center justify-between gap-3 flex-wrap">
            <div className="flex items-center gap-2 text-amber-800">
              <Clock className="h-4 w-4" />
              <span className="text-sm font-medium">{t("dash.trial.msg", { days: subscription.days_left })}</span>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => setPlanDlgOpen(true)} data-testid="trial-subscribe-button"
                className="inline-flex items-center gap-2 rounded-md px-3 h-9 bg-gradient-to-l from-blue-600 to-indigo-600 hover:opacity-90 text-white text-sm font-semibold transition">
                <Sparkles className="h-4 w-4" /> اشترك الآن وادفع
              </button>
              <a href={`https://wa.me/${subscription.support_whatsapp || SUPPORT_WHATSAPP}?text=${encodeURIComponent(t("dash.trial.waMsg"))}`}
                target="_blank" rel="noreferrer" data-testid="trial-subscribe-whatsapp"
                className="inline-flex items-center gap-2 rounded-md px-3 h-9 bg-[#25D366] hover:bg-[#1EBE57] text-white text-sm font-semibold transition">
                <MessageCircle className="h-4 w-4" /> واتساب
              </a>
            </div>
          </div>
        )}
        {view === "overview" && <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl bg-gradient-to-l from-blue-900 via-slate-900 to-slate-900 text-white p-6 md:p-10 shadow-xl">
          <div className="relative z-10 max-w-xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium mb-4">
              <BellRing className="h-3.5 w-3.5" /> {t("dash.hero.alertBefore", { d1: settings?.days_before ?? 7, d2: settings?.second_reminder_days ?? 1 })}
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-extrabold leading-snug">{t("dash.hero.title")}</h1>
            <p className="mt-3 text-slate-300 text-base leading-relaxed">
              {t("dash.hero.subtitle")}
            </p>
            {isManager ? (
              <Button data-testid="check-expiry-now-button" disabled={checking} onClick={handleCheckNow}
                className="mt-5 bg-[#25D366] hover:bg-[#1EBE57] text-white font-semibold active:scale-95 transition gap-2">
                <RefreshCw className={`h-4 w-4 ${checking ? "animate-spin" : ""}`} />
                {checking ? t("dash.hero.checking") : t("dash.hero.checkNow")}
              </Button>
            ) : (
              <div data-testid="viewer-note" className="mt-5 inline-flex items-center gap-2 rounded-xl bg-white/10 px-4 py-2.5 text-sm text-slate-200">
                <Eye className="h-4 w-4" /> {canEdit ? t("dash.hero.editNote") : t("dash.hero.viewNote")}
              </div>
            )}
          </div>
          <ShieldCheck className="absolute -left-6 -bottom-6 h-40 w-40 text-white/5" />
        </motion.div>}
        {view === "overview" && <AdsCarousel />}
        {view === "overview" && <div className="mb-4"><ApprovalInbox isOwner={user?.role === "manager"} /></div>}
        {view === "overview" && canEdit && <UploadCompliance />}

        <UsageMeter subscription={subscription} />

        <Tabs value={view} onValueChange={setView} dir={dir}>
          <div className="mb-3 flex flex-col sm:flex-row gap-2 sm:items-center">
            <div className="w-full sm:max-w-xs">
            <div className="flex items-center justify-between gap-2">
            <h2 data-testid="current-view-title" className="flex items-center gap-2 px-1 h-10 font-heading font-bold text-slate-800 text-base md:text-lg">
              <NavIcon value={view} className="text-blue-600" />
              {navModel.breadcrumbs[view] || t(`dash.nav.${view}`) || view}
            </h2>
            {view !== "overview" && view !== "private-docs" && <ReportExport getRoot={() => viewRef.current} title={navModel.breadcrumbs[view] || t(`dash.nav.${view}`) || view} />}
            </div>
            <Sheet open={navOpen} onOpenChange={setNavOpen}>
              <SheetContent side="right" dir={dir} className="w-[280px] p-0 flex flex-col gap-0 bg-gradient-to-b from-slate-900 to-slate-800 border-slate-700 text-slate-100" data-testid="mobile-nav-drawer">
                <SheetHeader className="p-4 border-b border-white/10 text-right space-y-0">
                  <SheetTitle className="font-heading text-base text-white">الأقسام</SheetTitle>
                  <SheetDescription className="sr-only">قائمة أقسام لوحة التحكم</SheetDescription>
                </SheetHeader>
                <nav className="flex-1 overflow-y-auto p-2 space-y-1">
                  {(() => {
                    const childCls = (on) => `flex w-full items-center gap-2.5 rounded-xl px-3 py-2 text-sm transition-colors ${on ? "bg-emerald-600 text-white font-semibold shadow-lg shadow-emerald-600/25" : "text-slate-300 hover:bg-white/10 hover:text-white"}`;
                    const isActive = (node) => {
                      if (node.kind === "leaf") return view === node.value;
                      if (node.kind === "special") return view === node.value || node.children.some((c) => view === c.value);
                      return node.children.some(isActive);
                    };
                    const renderNode = (node) => {
                      if (node.kind === "leaf") {
                        const active = view === node.value;
                        return (
                          <button key={node.value} data-testid={`view-option-${node.value}`}
                            onClick={() => { setView(node.value); setNavOpen(false); }}
                            className={`flex w-full items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm transition-colors ${active ? "bg-emerald-600 text-white font-semibold shadow-lg shadow-emerald-600/25" : "text-slate-300 hover:bg-white/10 hover:text-white"}`}>
                            <NavIcon value={node.value} className={active ? "text-white" : "text-slate-400"} />
                            <span className="flex-1 text-right">{node.label}</span>
                            {node.value === "correspondence" && unreadCorr > 0 && (
                              <span data-testid="corr-nav-badge" className="rounded-full bg-red-500 text-white text-[10px] font-mono-nums min-w-5 h-5 px-1.5 flex items-center justify-center">{unreadCorr}</span>
                            )}
                            {node.locked && <Lock className="h-3.5 w-3.5 text-amber-400" />}
                            {active && <span className="h-1.5 w-1.5 rounded-full bg-white" />}
                          </button>
                        );
                      }
                      const key = node.kind === "group" ? node.id : node.value;
                      const active = isActive(node);
                      const isExp = navExpanded[key] || active;
                      const GroupIcon = node.icon;
                      return (
                        <div key={`${key}-group`}>
                          <button data-testid={`view-option-${key}-group`}
                            onClick={() => setNavExpanded((g) => ({ ...g, [key]: !g[key] }))}
                            className={`flex w-full items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm transition-colors ${active ? "bg-white/10 text-white font-semibold" : "text-slate-300 hover:bg-white/10 hover:text-white"}`}>
                            {node.kind === "group"
                              ? <GroupIcon className={`h-5 w-5 ${active ? "text-white" : "text-slate-400"}`} />
                              : <NavIcon value={node.value} className={active ? "text-white" : "text-slate-400"} />}
                            <span className="flex-1 text-right">{node.label}</span>
                            {node.locked && <Lock className="h-3.5 w-3.5 text-amber-400" />}
                            <ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${isExp ? "rotate-180" : ""}`} />
                          </button>
                          {isExp && (
                            <div className="mt-1 mr-4 space-y-1 border-r border-white/10 pr-2">
                              {node.kind === "group"
                                ? node.children.map(renderNode)
                                : node.children.map((c) => (
                                    <button key={c.value} data-testid={`view-option-${c.value}`}
                                      onClick={() => { setView(c.value); setNavOpen(false); }}
                                      className={childCls(view === c.value)}>
                                      <NavIcon value={c.value} className={view === c.value ? "text-white" : "text-slate-400"} />
                                      <span className="flex-1 text-right">{c.label}</span>
                                      {view === c.value && <span className="h-1.5 w-1.5 rounded-full bg-white" />}
                                    </button>
                                  ))}
                            </div>
                          )}
                        </div>
                      );
                    };
                    return navModel.tree.map(renderNode);
                  })()}
                </nav>
              </SheetContent>
            </Sheet>
            </div>
            <div className="relative w-full sm:max-w-xs" data-testid="nav-search-box">
              <Search className={`absolute top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 ${dir === "rtl" ? "right-3" : "left-3"}`} />
              <Input data-testid="nav-search-input" value={navSearch}
                onChange={(e) => setNavSearch(e.target.value)}
                onFocus={() => setSearchFocused(true)}
                onBlur={() => setTimeout(() => setSearchFocused(false), 150)}
                type="search" name="nav-section-search" autoComplete="off"
                autoCorrect="off" autoCapitalize="off" spellCheck={false}
                placeholder={t("dash.nav.searchPlaceholder")}
                className={`h-12 rounded-xl bg-white shadow-sm ${dir === "rtl" ? "pr-9" : "pl-9"}`} />
              {navSearch.trim() && searchFocused && (
                <div data-testid="nav-search-results"
                  className="absolute z-30 mt-1 w-full max-h-72 overflow-y-auto rounded-xl border border-slate-200 bg-white shadow-lg p-1">
                  {(() => {
                    const q = normSearch(navSearch);
                    const searchItems = navModel.selectable;
                    const results = searchItems.filter((it) => normSearch(it.label).includes(q));
                    if (results.length === 0) {
                      return <p className="px-3 py-3 text-sm text-slate-400 text-center" data-testid="nav-search-empty">{t("dash.nav.searchEmpty")}</p>;
                    }
                    return results.map((it) => (
                      <button key={it.value} data-testid={`nav-search-option-${it.value}`}
                        onClick={() => { setView(it.value); setNavSearch(""); }}
                        className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm text-slate-700 hover:bg-blue-50 hover:text-blue-700 transition-colors">
                        <NavIcon value={it.value} className="text-slate-500" />
                        <span className="flex-1 text-start">{it.label}</span>
                        {it.locked && <Lock className="h-3.5 w-3.5 text-amber-500" />}
                      </button>
                    ));
                  })()}
                </div>
              )}
            </div>
            {reportDate && sector === "delivery" && canEdit && (
              <button data-testid="report-date-chip" onClick={() => setView("riders")}
                className="flex items-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 h-12 text-sm text-emerald-800 hover:bg-emerald-100 transition-colors shrink-0 w-full sm:w-auto justify-center">
                <CalendarDays className="h-4 w-4 text-emerald-600 shrink-0" />
                <span className="text-xs text-emerald-600">{t("dash.nav.reportDate")}</span>
                <span className="font-mono-nums font-bold" dir="ltr" data-testid="report-date-today">{new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Riyadh" })}</span>
                {reportDate !== new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Riyadh" }) && <span className="text-[10px] text-emerald-600" data-testid="report-date-last">آخر تقرير مرفوع <b dir="ltr">{reportDate}</b></span>}
              </button>
            )}
          </div>
          {["overview", "employees", "salaries"].includes(view) && <AnnouncementsBar page={view} />}
          <TabsList data-testid="view-tabs" className="hidden flex-wrap h-auto w-full justify-start gap-1 p-1.5 bg-slate-50/80">
            <TabsTrigger value="overview" data-testid="view-overview" className={NAV_TRIGGER_CLS}><NavIcon value="overview" />{t("dash.nav.overview")}</TabsTrigger>
            <TabsTrigger value="employees" data-testid="view-employees" className={NAV_TRIGGER_CLS}><NavIcon value="employees" />{t("dash.nav.employees")}</TabsTrigger>
            <TabsTrigger value="branches" data-testid="view-branches" className={NAV_TRIGGER_CLS}><NavIcon value="branches" />{t("dash.nav.branches")}{isLocked("branches") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>
            <TabsTrigger value="analytics" data-testid="view-analytics" className={NAV_TRIGGER_CLS}><NavIcon value="analytics" />{t("dash.nav.analytics")}{isLocked("analytics") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>
            <TabsTrigger value="custody" data-testid="view-custody" className={NAV_TRIGGER_CLS}><NavIcon value="custody" />{t("dash.nav.custody")}{isLocked("custody") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>
            <TabsTrigger value="vehicles" data-testid="view-vehicles" className={NAV_TRIGGER_CLS}><NavIcon value="vehicles" />{t("dash.nav.vehicles")}{isLocked("vehicles") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>
            <TabsTrigger value="company" data-testid="view-company" className={NAV_TRIGGER_CLS}><NavIcon value="company" />{t("dash.nav.company")}</TabsTrigger>
            {canEdit && <TabsTrigger value="insurance-individuals" data-testid="view-insurance-individuals" className={NAV_TRIGGER_CLS}><NavIcon value="insurance-individuals" />{t("dash.nav.insuranceIndividuals")}</TabsTrigger>}
            {canEdit && <TabsTrigger value="insurance-cars" data-testid="view-insurance-cars" className={NAV_TRIGGER_CLS}><NavIcon value="insurance-cars" />{t("dash.nav.insuranceCars")}</TabsTrigger>}
            {canEdit && <TabsTrigger value="insurance-moto" data-testid="view-insurance-moto" className={NAV_TRIGGER_CLS}><NavIcon value="insurance-moto" />{t("dash.nav.insuranceMoto")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="riders" data-testid="view-riders" className={NAV_TRIGGER_CLS}><NavIcon value="riders" />{t("dash.nav.riders")}{isLocked("riders") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="wallets" data-testid="view-wallets" className={NAV_TRIGGER_CLS}><NavIcon value="wallets" />{t("dash.nav.wallets")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="salary-sim" data-testid="view-salary-sim" className={NAV_TRIGGER_CLS}><NavIcon value="salary-sim" />{t("dash.nav.salarySim")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="rider-cash" data-testid="view-rider-cash" className={NAV_TRIGGER_CLS}><NavIcon value="rider-cash" />{t("dash.nav.riderCash")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="violations" data-testid="view-violations" className={NAV_TRIGGER_CLS}><NavIcon value="violations" />{t("dash.nav.violations")}{isLocked("violations") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="portal-usage" data-testid="view-portal-usage" className={NAV_TRIGGER_CLS}><NavIcon value="portal-usage" />{t("dash.nav.portalUsage")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="revenues" data-testid="view-revenues" className={NAV_TRIGGER_CLS}><NavIcon value="revenues" />{t("dash.nav.revenues")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="car-maintenance" data-testid="view-car-maintenance" className={NAV_TRIGGER_CLS}><NavIcon value="car-maintenance" />{t("dash.nav.carMaintenance")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="moto-maintenance" data-testid="view-moto-maintenance" className={NAV_TRIGGER_CLS}><NavIcon value="moto-maintenance" />{t("dash.nav.motoMaintenance")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="fuel" data-testid="view-fuel" className={NAV_TRIGGER_CLS}><NavIcon value="fuel" />{t("dash.nav.fuel")}{isLocked("fuel") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {canEdit && <TabsTrigger value="salaries" data-testid="view-salaries" className={NAV_TRIGGER_CLS}><NavIcon value="salaries" />{t("dash.nav.salaries")}{isLocked("salaries") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {canEdit && <TabsTrigger value="leave" data-testid="view-leave" className={NAV_TRIGGER_CLS}><NavIcon value="leave" />{t("dash.nav.leave")}{isLocked("leave") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {canEdit && <TabsTrigger value="loyalty" data-testid="view-loyalty" className={NAV_TRIGGER_CLS}><NavIcon value="loyalty" />{t("dash.nav.loyalty")}{isLocked("loyalty") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {canEdit && <TabsTrigger value="purchases" data-testid="view-purchases" className={NAV_TRIGGER_CLS}><NavIcon value="purchases" />{t("dash.nav.purchases")}</TabsTrigger>}
            {sector === "delivery" && canEdit && <TabsTrigger value="perf-alerts" data-testid="view-perf-alerts" className={NAV_TRIGGER_CLS}><NavIcon value="perf-alerts" />{t("dash.nav.perfAlerts")}{isLocked("perf_alerts") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {sector === "retail" && <TabsTrigger value="sales" data-testid="view-sales" className={NAV_TRIGGER_CLS}><NavIcon value="sales" />{t("dash.nav.sales")}{isLocked("sales") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            <TabsTrigger value="attendance" data-testid="view-attendance" className={NAV_TRIGGER_CLS}><NavIcon value="attendance" />{t("dash.nav.attendance")}{isLocked("attendance") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>
            <TabsTrigger value="advances" data-testid="view-advances" className={NAV_TRIGGER_CLS}><NavIcon value="advances" />{t("dash.nav.advances")}{isLocked("advances") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>
            {canEdit && <TabsTrigger value="alerts" data-testid="view-alerts" className={NAV_TRIGGER_CLS}><NavIcon value="alerts" />{t("dash.nav.alerts")}{isLocked("alerts") && <Lock className="h-3 w-3 text-amber-500" />}</TabsTrigger>}
            {canEdit && <TabsTrigger value="faq-contacts" data-testid="view-faq-contacts" className={NAV_TRIGGER_CLS}><NavIcon value="faq-contacts" />الأسئلة والأرقام</TabsTrigger>}
          </TabsList>
        </Tabs>

        {view !== "overview" && <BackBar onBack={goBack} />}
        {view === "overview" && !previewAs && <AdminReportsDueCard onOpen={() => { sessionStorage.setItem("corr_tab_once", "reports"); setView("correspondence"); }} />}
        {view === "overview" && !previewAs && <MissingDocsCard canManage={isManager} onPickEmployee={(m) => { setMissingDoc(null); setAttrFilter(null); setBranchFilter("all"); setFilter("all"); setSearch(m.name); setView("employees"); }} />}
        {(view === "overview" || view === "employees") && stats?.upcoming?.length > 0 && (
          <UpcomingAlerts items={stats.upcoming}
            onPick={(u) => {
              if (u.attachment_id) { setDocPreview({ id: u.attachment_id, name: u.attachment_name || u.document, employeeId: u.employee_id, employeeName: u.employee }); return; }
              const emp = employees.find((e) => e.id === u.employee_id);
              if (emp) { setViewing(emp); return; }
              setMissingDoc(null); setAttrFilter(null); setBranchFilter("all"); setFilter("all"); setSearch(u.employee); setView("employees");
            }}
            onGroup={(doc, list) => { setMissingDoc(null); setBranchFilter("all"); setFilter("all"); setSearch(""); setAttrFilter({ field: "ids", value: doc, ids: list.map((u) => u.employee_id).filter(Boolean) }); setView("employees"); }} />
        )}
        <InAppFilePreview file={docPreview} onClose={() => setDocPreview(null)} />

        <div ref={viewRef} data-testid="view-content" className="space-y-4">
        {view === "overview" ? (
          <OverviewPanel isManager={isManager} onNav={(action) => {
            const clearEmp = () => { setSearch(""); setBranchFilter("all"); setMissingDoc(null); setAttrFilter(null); };
            if (action === "employees") { clearEmp(); setFilter("all"); setView("employees"); }
            else if (action === "docs-valid") { clearEmp(); setFilter("valid"); setView("employees"); }
            else if (action === "docs-expiring") { clearEmp(); setFilter("expiring_soon"); setView("employees"); }
            else if (action === "docs-expired") { clearEmp(); setFilter("expired"); setView("employees"); }
            else if (action === "branches") { setView("branches"); }
            else if (action === "custody") { setView("custody"); }
            else if (action === "company") { setView("company"); }
            else if (action === "riders") { setView("riders"); }
            else if (action === "saudi-files") { setView("saudi-files"); }
            else if (action === "residents" || action === "saudis") { clearEmp(); setFilter("all"); setAttrFilter({ field: "natgroup", value: action === "saudis" ? "سعودي" : "مقيم" }); setView("employees"); }
            else if (action.startsWith("branch:")) { clearEmp(); setFilter("all"); setBranchFilter(action.slice(7)); setView("employees"); }
            else if (action.startsWith("nat:")) { clearEmp(); setFilter("all"); setAttrFilter({ field: "nationality", value: action.slice(4) }); setView("employees"); }
            else if (action === "users") { setOrgOpen(true); }
            else if (action === "departments") { setCompanyTab("departments"); setCompanyOpen(true); }
          }} />
        ) : view === "branches" || view === "analytics" ? (
          gate("branches", <InfoHub canEdit={sectionCanEdit}
            platforms={<PlatformBoxes canEdit={sectionCanEdit} />}
            stats={<AnalyticsPanel refreshKey={employees.length} branchOptions={branchOptions}
              onFilter={(field, value) => { setMissingDoc(null); setAttrFilter({ field, value }); setSearch(""); setBranchFilter("all"); setFilter("all"); setView("employees"); }}
              onMissingDoc={(key, label) => { setAttrFilter(null); setMissingDoc({ key, label }); setSearch(""); setBranchFilter("all"); setFilter("all"); setView("employees"); }} />}
            branches={<BranchesPanel isManager={isManager} onSelectBranch={(b) => { setBranchFilter(b); setFilter("all"); setSearch(""); setView("employees"); }} />} />)
        ) : view === "custody" ? (
          gate("custody", <CustodyPanel employees={employees} branchOptions={branchOptions} canEdit={sectionCanEdit} isManager={isManager || user?.role === "hr_manager"} />)
        ) : view === "vehicles" ? (
          gate("vehicles", <VehiclesPanel employees={employees} branchOptions={branchOptions} canEdit={sectionCanEdit} />)
        ) : view === "rentals" ? (
          <RentalsPanel canEdit={sectionCanEdit} employees={employees} />
        ) : view === "company" ? (
          gate("company_records", <CompanyRecordsPanel canEdit={sectionCanEdit} />)
        ) : view === "correspondence" ? (
          <CorrespondenceHub user={user} onUnreadChange={bumpCorrUnread} onManageUsers={() => setOrgOpen(true)} />
        ) : view === "insurance-all" || view === "insurance-individuals" ? (
          <InsurancePanel type="individuals" canEdit={sectionCanEdit} />
        ) : view === "insurance-cars" ? (
          <InsurancePanel type="cars" canEdit={sectionCanEdit} />
        ) : view === "insurance-moto" ? (
          <InsurancePanel type="moto" canEdit={sectionCanEdit} />
        ) : view === "riders" ? (
          gate("riders", <RidersPanel canEdit={sectionCanEdit} />)
        ) : view === "riders-daily" ? (
          gate("riders", <RidersDailyPanel employees={employees} />)
        ) : view === "riders-compare" ? (
          gate("riders", <RidersComparePanel />)
        ) : view === "riders-target" ? (
          gate("riders", <RidersTargetPanel />)
        ) : view === "riders-distances" ? (
          gate("riders", <RidersDistancesPanel canEdit={sectionCanEdit} />)
        ) : view === "riders-rented" ? (
          gate("riders", <RentedAccountsPanel canEdit={sectionCanEdit} />)
        ) : view === "wallets" ? (
          <WalletsPanel canEdit={sectionCanEdit} />
        ) : view === "salary-sim" ? (
          <RevenueForecast />
        ) : view === "rider-cash" ? (
          <RiderCashPanel employees={employees} />
        ) : view === "accidents" ? (
          <AccidentsPanel employees={employees} canEdit={sectionCanEdit} />
        ) : view === "violations" ? (
          gate("violations", <ViolationsPanel canEdit={sectionCanEdit} employees={employees} />)
        ) : view === "portal-usage" ? (
          <PortalUsagePanel />
        ) : view === "revenues" ? (
          <RevenuePanel canEdit={sectionCanEdit} />
        ) : view === "reports-hub" ? (
          <ReportsHubPanel onNavigate={setView} sector={sector} canEdit={canEdit} />
        ) : view === "spareparts" ? (
          gate("spareparts", <SparePartsPanel canEdit={sectionCanEdit} />)
        ) : view === "car-maintenance" ? (
          gate("spareparts", <CarMaintenancePanel canEdit={sectionCanEdit} />)
        ) : view === "moto-maintenance" ? (
          gate("spareparts", <MotoMaintenancePanel canEdit={sectionCanEdit} />)
        ) : view === "fuel" ? (
          gate("fuel", <FuelPanel canEdit={sectionCanEdit} />)
        ) : view === "salaries" ? (
          gate("salaries", <SalariesPanel canEdit={sectionCanEdit} />)
        ) : view === "leave" ? (
          gate("leave", <LeaveBoard mode="manager" canEdit={sectionCanEdit} />)
        ) : view === "injuries" ? (
          gate("injuries", <InjuriesPanel canEdit={sectionCanEdit} employees={employees} />)
        ) : view === "loyalty" ? (
          gate("loyalty", <LoyaltyPanel canEdit={sectionCanEdit} />)
        ) : view === "purchases" ? (
          <PurchasesPanel canEdit={sectionCanEdit} />
        ) : view === "workspace" ? (
          <WorkspacePanel />
        ) : view === "meetings" ? (
          <MeetingsPanel employees={employees} />
        ) : view === "biz-calendar" ? (
          <BusinessCalendar employees={employees} />
        ) : view === "perf-alerts" ? (
          gate("perf_alerts", <PerfAlertsPanel />)
        ) : view === "sales" ? (
          gate("sales", <SalesPanel canEdit={sectionCanEdit} branches={branches} employees={employees} />)
        ) : view === "attendance" ? (
          gate("attendance", <AttendancePanel canEdit={sectionCanEdit} branches={branches} employees={employees} />)
        ) : view === "pnl" ? (
          gate("pnl", <PnlPanel />)
        ) : view === "var-expenses" ? (
          gate("var-expenses", <VarExpensesPanel canEdit={sectionCanEdit} isManager={isManager || user?.role === "accountant"} employees={employees} />)
        ) : view === "advances" ? (
          gate("advances", <AdvancesPanel canEdit={sectionCanEdit} employees={employees} />)
        ) : view === "tasks" ? (
          <TasksPanel canEdit={sectionCanEdit} />
        ) : view.startsWith("legal-") ? (
          <LegalPanel key={view} view={view} employees={employees} onNavigate={setView} />
        ) : view === "decisions" ? (
          <DecisionsPanel canEdit={sectionCanEdit} employees={employees} />
        ) : view === "contracts" ? (
          <ContractsPanel />
        ) : view === "private-docs" ? (
          <PrivateDocsPanel />
        ) : view === "outlook" ? (
          <OutlookPanel />
        ) : view === "wa-messages" ? (
          <WaMessagesPanel employees={employees} />
        ) : view === "library" ? (
          <LibraryPanel canEdit={sectionCanEdit} isOwner={user?.role === "manager"} />
        ) : view === "live-roster" ? (
          <Suspense fallback={<div className="grid h-96 place-items-center text-slate-400">…</div>}><LiveRosterPanel isOwner={isManager} /></Suspense>
        ) : view === "rider-map" ? (
          <Suspense fallback={<div className="grid h-96 place-items-center text-slate-400">…</div>}><RiderMapPanel /></Suspense>
        ) : view === "rider-cards" ? (
          trialLocked ? (
            <div data-testid="rider-cards-locked" className="rounded-2xl border border-dashed border-amber-300 bg-amber-50/60 px-6 py-16 text-center">
              <Lock className="mx-auto mb-3 h-10 w-10 text-amber-600" />
              <h3 className="font-heading text-xl font-bold">بطاقات المناديب متاحة للمشتركين فقط</h3>
              <p className="mt-2 text-sm text-slate-500">اشترك الآن لإصدار بطاقات المناديب وتصميمها وطباعتها.</p>
              <button data-testid="rider-cards-subscribe" onClick={() => setPlanDlgOpen(true)} className="mt-5 inline-flex h-11 items-center gap-2 rounded-xl bg-blue-600 px-6 font-semibold text-white transition-colors hover:bg-blue-700">اشترك الآن</button>
            </div>
          ) : <RiderCardsPanel canEdit={sectionCanEdit} />
        ) : view === "saudi-files" ? (
          <SaudiFilesPanel canEdit={sectionCanEdit} />
        ) : view === "alerts" ? (
          gate("alerts", <AlertsPanel />)
        ) : view === "faq-contacts" ? (
          <FaqContactsPanel canEdit={sectionCanEdit} />
        ) : view === "lockers" ? (
          <LockerSection canEdit={sectionCanEdit} />
        ) : (
          <>
            <EmpDocsStats className="mb-1" reloadKey={employees}
              activeKey={attrFilter?.field === "active" ? "active" : attrFilter?.field === "natgroup" ? (attrFilter.value === "سعودي" ? "saudis" : "residents")
                : !attrFilter && filter !== "all" ? { valid: "docs-valid", expiring_soon: "docs-expiring", expired: "docs-expired" }[filter] : ""}
              onPick={(k) => {
                setSearch(""); setBranchFilter("all"); setMissingDoc(null); setAttrFilter(null);
                setFilter({ "docs-valid": "valid", "docs-expiring": "expiring_soon", "docs-expired": "expired" }[k] || "all");
                if (k === "active") setAttrFilter({ field: "active", value: "نشط" });
                if (k === "saudis" || k === "residents") setAttrFilter({ field: "natgroup", value: k === "saudis" ? "سعودي" : "مقيم" });
                setTimeout(() => document.querySelector('[data-testid="status-filter-tabs"]')?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
              }} />
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
              <Tabs value={filter} onValueChange={setFilter} dir={dir}>
                <TabsList data-testid="status-filter-tabs">
                  <TabsTrigger value="all" data-testid="filter-status-all">{t("dash.filters.all")}</TabsTrigger>
                  <TabsTrigger value="valid" data-testid="filter-status-valid">{t("dash.status.valid")}</TabsTrigger>
                  <TabsTrigger value="expiring_soon" data-testid="filter-status-expiring">{t("dash.status.expiring_soon")}</TabsTrigger>
                  <TabsTrigger value="expired" data-testid="filter-status-expired">{t("dash.status.expired")}</TabsTrigger>
                </TabsList>
              </Tabs>
              <div className="flex flex-wrap md:flex-nowrap items-center gap-2 w-full md:w-auto">
                <Select value={branchFilter} onValueChange={setBranchFilter}>
                  <SelectTrigger data-testid="branch-filter-select" className="w-36 shrink-0">
                    <SelectValue placeholder={t("dash.filters.allBranches")} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">{t("dash.filters.allBranches")}</SelectItem>
                    {branchOptions.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}
                  </SelectContent>
                </Select>
                <div className="relative order-first basis-full md:order-none md:basis-auto md:flex-1 md:w-64 min-w-0">
                  <Search className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                  <Input data-testid="search-input" placeholder={t("dash.filters.searchPlaceholder")}
                    value={search} onChange={(e) => setSearch(e.target.value)} className="pr-9" />
                </div>
                {view === "employees" && <div className="flex gap-2"><BulkTools section="employees" merge onDone={refresh} /></div>}
              </div>
            </div>

            {loading ? (
              <div className="py-16 text-center text-slate-400">{t("dash.loading")}</div>
            ) : (
              <>
                <EmpExtraFilters employees={employees} xf={xf} setXf={setXf} snapshot={{ xf, filter, branchFilter, search }}
                  onApply={(st) => { setAttrFilter(null); setMissingDoc(null); setXf(st.xf || {}); setFilter(st.filter || "all"); setBranchFilter(st.branchFilter || "all"); setSearch(st.search || ""); }} />
                {missingDoc && (
                  <div data-testid="missing-doc-filter-chip" className="flex items-center gap-2">
                    <span className="inline-flex items-center gap-2 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-sm px-3 py-1.5">
                      <AlertTriangle className="h-3.5 w-3.5" />
                      {t("dash.filters.missingPrefix")} <span className="font-semibold">{missingDoc.label}</span>
                      <button data-testid="clear-missing-doc-filter" onClick={() => setMissingDoc(null)}
                        className="mr-1 rounded-full hover:bg-amber-100 p-0.5"><X className="h-3.5 w-3.5" /></button>
                    </span>
                  </div>
                )}
                {attrFilter && (
                  <div data-testid="attr-filter-chip" className="flex items-center gap-2">
                    <span className="inline-flex items-center gap-2 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-sm px-3 py-1.5">
                      <Search className="h-3.5 w-3.5" />
                      {{ nationality: t("dash.filters.attr.nationality"), profession: t("dash.filters.attr.profession"), status: t("dash.filters.attr.status"), vehicle: t("dash.filters.attr.vehicle"), natgroup: "الفئة", active: "الحالة", ids: "وثيقة" }[attrFilter.field]}: <span className="font-semibold">{attrFilter.value}</span>
                      <button data-testid="clear-attr-filter" onClick={() => setAttrFilter(null)}
                        className="mr-1 rounded-full hover:bg-blue-100 p-0.5"><X className="h-3.5 w-3.5" /></button>
                    </span>
                  </div>
                )}
                {canEdit ? (
                  <BulkBranchBar selected={selEmp} setSelected={setSelEmp} filteredIds={filtered.map((e) => e.id)} branchOptions={branchOptions} onDone={refresh}>
                    <EmployeesExport employees={filtered} selected={selEmp} />
                    <BulkContractType selected={selEmp} onDone={refresh} />
                    <BulkPlatform selected={selEmp} onDone={refresh} />
                    <BulkVehicleType selected={selEmp} onDone={refresh} />
                    <BulkFuelChargeMode selected={selEmp} onDone={refresh} />
                    <DocFolderImport employees={employees} onDone={refresh} />
                    <KeetaLinkExcel onDone={refresh} />
                    <Button variant="outline" size="sm" className="h-8 gap-1.5 border-emerald-200 text-xs text-emerald-700" data-testid="open-muqeem-import-button" onClick={() => setMuqeemOpen(true)}>
                      <ShieldCheck className="h-3.5 w-3.5" /> استيراد من مقيم
                    </Button>
                    {canEdit && <IqamaRenewalsButton onClosed={refresh} />}
                    {["manager", "hr_manager"].includes(user?.role) && <EmployeesTrashButton onRestored={refresh} />}
                  </BulkBranchBar>
                ) : <EmployeesExport employees={filtered} selected={selEmp} />}
                <EmployeeTable
                  employees={paged}
                  selected={selEmp}
                  onToggle={(id) => setSelEmp((p) => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; })}
                  onTogglePage={(ids, on) => setSelEmp((p) => { const n = new Set(p); ids.forEach((id) => (on ? n.add(id) : n.delete(id))); return n; })}
                  readOnly={!canEdit}
                  onRefresh={refresh}
                  duplicateIqamas={duplicateIqamas}
                  onView={(e) => setViewing(e)}
                  onFilterStatus={(s) => { setAttrFilter(null); setMissingDoc(null); setFilter(s); }}
                  onOpenFile={(d, e) => setDocPreview({ id: d.attachment_id, name: d.attachment_name || d.label, employeeId: e.id, employeeName: e.name })}
                  onEdit={(e) => { setEditing(e); setEmpDialog(true); }}
                  onDelete={(e) => setDeleteTarget(e)}
                />
                {filtered.length > 0 && (
                  <div data-testid="pagination-bar" className="flex items-center justify-between gap-3 flex-wrap pt-1">
                    <div className="flex items-center gap-2 text-sm text-slate-500">
                      <span>{t("dash.pagination.show")}</span>
                      <Select value={String(pageSize)} onValueChange={(v) => setPageSize(Number(v))}>
                        <SelectTrigger data-testid="page-size-select" className="w-24 h-9"><SelectValue /></SelectTrigger>
                        <SelectContent>
                          {[20, 50, 100].map((n) => <SelectItem key={n} value={String(n)}>{n}</SelectItem>)}
                          <SelectItem value="100000">{t("dash.pagination.all")}</SelectItem>
                        </SelectContent>
                      </Select>
                      <span>{t("dash.pagination.ofEmployees", { n: filtered.length })}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Button variant="outline" size="sm" data-testid="page-prev" disabled={currentPage <= 1}
                        onClick={() => setPage(currentPage - 1)}>{t("dash.pagination.prev")}</Button>
                      <span className="text-sm text-slate-600 font-mono-nums">{t("dash.pagination.pageXofY", { c: currentPage, t: totalPages })}</span>
                      <Button variant="outline" size="sm" data-testid="page-next" disabled={currentPage >= totalPages}
                        onClick={() => setPage(currentPage + 1)}>{t("dash.pagination.next")}</Button>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
        </div>
      </main>

      <EmployeeDialog
        open={empDialog}
        onOpenChange={(v) => { setEmpDialog(v); if (!v) setEditing(null); }}
        onSaved={refresh}
        initial={editing}
        existingEmployees={employees}
        branchOptions={branchOptions}
        onOpenEmployee={(e) => { setEmpDialog(false); setEditing(null); setViewing(e); }}
      />
      <EmployeeDetailDialog open={Boolean(viewing)} onOpenChange={(v) => !v && setViewing(null)} employee={viewing} editable={canEdit} onUpdated={refresh} />
      <ImportDialog open={importOpen} onOpenChange={setImportOpen} onImported={refresh} />
      <MuqeemImportDialog open={muqeemOpen} onOpenChange={setMuqeemOpen} onImported={refresh} />
      <RiderIdImportDialog open={riderImportOpen} onOpenChange={setRiderImportOpen} onImported={refresh} />
      <PlanPickerDialog open={planDlgOpen} onOpenChange={setPlanDlgOpen} subscription={subscription} />
      <MergedDocsExportDialog open={mergedDocsOpen} onOpenChange={setMergedDocsOpen} />
      <ShareLinkDialog open={!!shareLink} onOpenChange={(v) => { if (!v) setShareLink(null); }} link={shareLink} />
      <ReportDialog open={reportOpen} onOpenChange={setReportOpen} />
      <ChangePasswordDialog open={pwOpen} onOpenChange={setPwOpen} />
      {!previewAs && <ForcePinGate />}
      {isManager && <OrgStructureDialog open={orgOpen} onOpenChange={(v) => { setOrgOpen(v); if (!v) setPermRefresh((n) => n + 1); }} onPreview={setPreviewAs} />}
      {previewAs && <PreviewBanner name={previewAs.name} onExit={() => { setPreviewAs(null); setOrgOpen(true); }} />}
      <AdminOrgsDialog open={adminOpen} onOpenChange={setAdminOpen} initialTab={adminTab} visibleTabs={["identity", "announcements", "design"]} />
      <MarketingAdminPanel open={marketingOpen} onOpenChange={setMarketingOpen} initialTab={marketingTab} />
      <StatementDialog open={statementOpen} onOpenChange={setStatementOpen} employees={employees} />
      <CompanySettingsDialog open={companyOpen} onOpenChange={(v) => { setCompanyOpen(v); if (!v) setCompanyTab("profile"); }} initialTab={companyTab} onSaved={(s) => { if (s) setSector(s); refresh(); }}
        notif={isManager && settings ? { settings, onSave: handleSaveSettings, onTest: handleTestWhatsapp, onTestEmail: handleTestEmail } : null} />
      <OperatingCardsDialog open={opCardsOpen} onOpenChange={setOpCardsOpen} onSaved={refresh} />
      <NationalityMergeDialog open={natOpen} onOpenChange={setNatOpen} onSaved={refresh} />
      <SupportWidget />

      <AlertDialog open={Boolean(deleteTarget)} onOpenChange={(v) => !v && setDeleteTarget(null)}>
        <AlertDialogContent dir={dir} className="font-body">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-heading text-right">{t("dash.del.title")}</AlertDialogTitle>
            <AlertDialogDescription className="text-right">
              {t("dash.del.desc", { name: deleteTarget?.name })}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex-row-reverse gap-2 sm:justify-start">
            <AlertDialogAction data-testid="confirm-delete-button" onClick={handleDelete} className="bg-red-600 hover:bg-red-700">{t("dash.del.confirm")}</AlertDialogAction>
            <AlertDialogCancel>{t("dash.del.cancel")}</AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
